<div fxLayout="column wrap">
  <div fxLayout="row wrap" fxFlex="100" class="text-center mt-2">
    <form [formGroup]="billingForm" (ngSubmit)="onSubmit()">
      <div fxLayout="row wrap" fxFlex.gt-sm="47">
        <h3>Billing Address</h3>
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="Address (street, apartment, suite, unit etc.)"
              formControlName="invoiceToAddress" required>
            <mat-error *ngIf="billingForm.controls.invoiceToAddress.errors?.required">Address is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="Phone" formControlName="invoiceToPhone" required>
            <mat-error *ngIf="billingForm.controls.invoiceToPhone.errors?.required">Phone is required</mat-error>
          </mat-form-field>
        </div>

        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="City" formControlName="invoiceToCity" required>
            <mat-error *ngIf="billingForm.controls.invoiceToCity.errors?.required">City is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-select  formControlName="invoiceToState">
              <mat-option *ngFor="let state of states" [value]="state.stateName">
                <span>{{state.stateName}}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="Zip/Postal Code" formControlName="invoiceToPin" required>
            <mat-error *ngIf="billingForm.controls.invoiceToPin.errors?.required">Zip/Postal Code is required
            </mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="GSTIN/UIN" formControlName="invoiceToGSTINUIN" required>
            <mat-error *ngIf="billingForm.controls.invoiceToGSTINUIN.errors?.required">GST/UIN is required</mat-error>
          </mat-form-field>

        </div>
      </div>
      <div fxLayout="row wrap" fxFlex.gt-sm="6"></div>

      <div fxLayout="row wrap" fxFlex.gt-sm="47">
        <h3>Shipping Address</h3>
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="Address (street, apartment, suite, unit etc.)" formControlName="shipToAddress"
              required>
            <mat-error *ngIf="billingForm.controls.shipToAddress.errors?.required">Address is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="Phone" formControlName="shipToPhone" required>
            <mat-error *ngIf="billingForm.controls.shipToPhone.errors?.required">Phone is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="City" formControlName="shipToCity" required>
            <mat-error *ngIf="billingForm.controls.shipToCity.errors?.required">City is required</mat-error>
          </mat-form-field>
        </div>
        <!-- <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="State" formControlName="shipToState">
          </mat-form-field>
        </div> -->
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <mat-select  formControlName="shipToState">
              <mat-option *ngFor="let state of states" [value]="state.stateName">
                <span>{{state.stateName}}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <mat-form-field appearance="outline" class="w-100">
            <input matInput placeholder="Zip/Postal Code" formControlName="shipToPin" required>
            <mat-error *ngIf="billingForm.controls.shipToPin.errors?.required">Zip/Postal Code is required</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="100" class="px-1">
          <button mat-flat-button color="primary" class="mat-elevation-z6" type="submit">Save</button>
        </div>
      </div>
    </form>
  </div>
</div>